<mat-spinner [strokeWidth]="strokeWidth" class="loading-circle"
             [diameter]="getBySize()"
             [color]="color"
             [style]="style ? style : null"></mat-spinner>


